/* @ngInject */
export default function pc3panel($compile, PanelTypes, $window, ResponsiveBreakpoints) {
  return {
    replace: true,
    template:
        `<li class="panel panel-stat pc-panel">
          <div class="panel-content-wrapper">
            <div class="panel-content"></div>
          </div>
        </li>`,
    bindToController: {
      panel: '<',
    },
    controller($scope, $element) {
      'ngInject';

      const vm = this;
      this.$onInit = () => {
        const panelBody = angular.element($element).find('.panel-content');
        let panelContent = PanelTypes[vm.panel.type].tag;

        // compile the panel content and append it to the panel
        panelContent = $compile(panelContent)($scope);
        panelBody.append(panelContent);

        const MIN_WIDTH_LARGE = ResponsiveBreakpoints.largeTablet.minSize;
        const MIN_WIDTH_MEDIUM = ResponsiveBreakpoints.smallTablet.minSize;
        const MIN_WIDTH_SMALL = 320;
        const THROTTLE_DELAY = 25; // chose a busy dashboard, inspected $digest duration for rough number

        const classPrefix = 'gridster-width-';
        const allClasses = `${classPrefix}lg ${classPrefix}md ${classPrefix}sm ${classPrefix}xs`;

        const elComputedStyleDeclaration = $window.getComputedStyle($element[0], null);

        const throttledGristerClassUpdate = _.throttle((newWidth) => {
          const parsedWidth = parseInt(newWidth, 10);
          let newClass = '';

          if (parsedWidth >= MIN_WIDTH_LARGE) {
            newClass = `${classPrefix}lg`;
          } else if (parsedWidth >= MIN_WIDTH_MEDIUM) {
            newClass = `${classPrefix}md`;
          } else if (parsedWidth >= MIN_WIDTH_SMALL) {
            newClass = `${classPrefix}sm`;
          } else if (parsedWidth < MIN_WIDTH_SMALL) {
            newClass = `${classPrefix}xs`;
          }

          $element.removeClass(allClasses).addClass(newClass);
        }, THROTTLE_DELAY);

        $scope.$watch(() => elComputedStyleDeclaration.width, throttledGristerClassUpdate);
      };
    },
    controllerAs: 'pc3PanCtrl',
  };
}
